// removed by extract-text-webpack-plugin
module.exports = {"conjunction":"_-src-components-AutocompleteList-index---conjunction---1TAEV","list":"_-src-components-AutocompleteList-index---list---1REMR","itemWrapper":"_-src-components-AutocompleteList-index---itemWrapper---7DX72","itemHeader":"_-src-components-AutocompleteList-index---itemHeader---xUvZb","itemDescription":"_-src-components-AutocompleteList-index---itemDescription---svINx","onlyNewButton":"_-src-components-AutocompleteList-index---onlyNewButton---2YsNG","error":"_-src-components-AutocompleteList-index---error---1jK08","loader":"_-src-components-AutocompleteList-index---loader---1g1Zx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AutocompleteList/index.css
// module id = 810
// module chunks = 1